import React, { useContext } from 'react';

import {
    makeStyles,
    Typography,
    Box
} from '@material-ui/core';
import {
    api,
    esGestiona,
    IconPapelera,
    Link,
    PortalContext
} from '@portal/arq-portal-core';
import { useSWRConfig } from 'swr';

import { FavoritosContext } from '../context/FavoritosContext';
import { CustomTooltip } from './CustomTooltip';

const useEstilos = makeStyles(() => ({
    titulo: {
        color: '#555'
    },
    root: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: '0.3rem 0 0.3rem 1rem',
        width: 'calc(100% - 20px)',
        "&:hover": {
            cursor: "default",
            "& $titulo": {
                fontWeight: "bold"
            },
            "& $icono": {
                display: "flex"
            }
        },
        '& .MuiBox-root': {
            width: '100%',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            color: '#606060',
            '&:hover': {
                color: '#919191',
            },
            '&:focus, &:active': {
                color: '#DC0028',
            },
        },
    },
    icono: {
        display: 'none',
        cursor: 'pointer'
    },
    extra:{
        padding: '8px',
    }
}));

interface EnlacePersonalProps {
    item: any;
};

export const EnlacePersonal = ({ item }: EnlacePersonalProps) => {

    const clases = useEstilos();

    const { mutate } = useSWRConfig();
    const { setEnlaceClick, favoritosSWRKey, actualizarIdClick} = useContext(FavoritosContext);
    const { user } = useContext(PortalContext);

    const manejarCierre = () => {
        mutate([favoritosSWRKey, user?.id], ()=>api.post("/be/favsdel", {Entrada:{Url: item.Url, Tipo: 'Personales'}}), false);
    };

    return (
        <div className={  esGestiona()? clases.root: clases.root + ' ' + clases.extra}>
            <Box onClick={() => setEnlaceClick(true)}>
                <Link to={item.Url} actualizarIdClick={actualizarIdClick}>
                    <CustomTooltip title={item.Url} placement="bottom-start">
                        <Typography variant="caption" component="div" classes={{ root: clases.titulo }}>{item.Titulo}</Typography>
                    </CustomTooltip>
                </Link>
            </Box>
            <IconPapelera size='small' className={clases.icono} onClick={manejarCierre} />
        </div>
    );
};